export default __webpack_public_path__ + "static/FS2S-InHub-103-60af6e7c18ead155af9feaf16eadd121.jpg";